module.exports = __webpack_public_path__ + "a66684bcd9a6e9dc4c0af0fc1d8229f9.svg";